import { render, staticRenderFns } from "./PDAsao.vue?vue&type=template&id=7227ab9e&scoped=true"
import script from "./PDAsao.vue?vue&type=script&lang=js"
export * from "./PDAsao.vue?vue&type=script&lang=js"
import style0 from "./PDAsao.vue?vue&type=style&index=0&id=7227ab9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7227ab9e",
  null
  
)

export default component.exports